import React from 'react';
import { CockpitButton } from 'components/views/atoms/CockpitButton';
import { faCarCrash } from '@fortawesome/free-solid-svg-icons';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';

export type EmergencyButtonProps = {
    size?: SizeProp;
    onClick?: () => void;
}

export const EmergencyButton = (props: EmergencyButtonProps) => {
    return (
        <CockpitButton icon={faCarCrash} color='red' {...props} />
    );
};
